export const environment = {
  production: false,
  bApi: 'https://www2.analisecriminal.muralhapaulista.sp.gov.br/api/v1/',
  bRep: '/',
  bRepR10: '/',
  igb: 'https://idp.sp.gov.br/auth/realms/idpsp',
  issuer: 'https://idp.sp.gov.br/auth/realms/idpsp',
  sgbApi: 'https://govbr-service.idp-prd.sp.gov.br/userinfo/confiabilidades/detalhe',
  cgb: 'ssp.analisecriminal',
  spgb: 'Prata;Ouro',
  scpgb: 'openid profile govbr_confiabilidades',
  mlg: false,
  siteKey: '6LcXeQ8sAAAAAGl4aOmbdfRIpkj8zbK1QK78HhRT',
  clientId: 'ssp.analisecriminal',
  utilAuth: '67636215-DEEE-445A-93F4-D37114FB8633',
  envName: 'Homologação',
  // === CyberArk Identity (Portal Minha Área SP) ===
  cyberArkEnabled: true,
  ica: 'https://abc4967.id.cyberark.cloud/analise_criminal_hml/',
  cca: 'fb1de56d-d5d9-4ff3-9815-821e73590aef',
  cyberArkMinhaArea: 'https://hml.minhaarea.sp.gov.br/plataformasp',
  periodoEleitoral: true
};

export function getEnvironment() {
  return environment;
}

export function isProduction() {
  return environment.production;
}
